import { Types } from "Types";
import { useDispatch, useSelector } from "react-redux";
import {
  ActionCreators as AdbActionCreator,
  Selectors as AdbSelector,
} from "../../../redux/AdministrateurDeBien";
import { Selectors as UtilisateurSelector } from "../../../redux/Utilisateurs";
import { useGetAdbDetail } from "../../../hooks/AdministrateurDeBien";
import { Site } from "../../../services/Api/swagger";
// const mapStateToProps = state => ({
//   utilisateurConnecte: UtilisateurSelector.getUtilisateurConnecte(state),
//   adbDetail: AdbSelector.getADBDetail(state),
//   adbFetching: AdbSelector.getADBFetching(state),
//   adbError: AdbSelector.getADBError(state),
//   selectedAdbDetail: AdbSelector.getSelectedAdbDetail(state),
//   selectedSiteDetails: AdbSelector.getSelectedSite(state),
//   idAdb: AdbSelector.getAdbId(state),
// });

// const mapDispatchToProps = (dispatch: Dispatch) => ({
//   getAdbDetail: (idAdb: number) =>
//     dispatch(AdbActionCreator.getADBIdDetail.request(idAdb)),
//   setSelectedSite: (site: Site) =>
//     dispatch(AdbActionCreator.setSelectedSite(site)),
//   updateAdbId: (id: number) => dispatch(AdbActionCreator.updateAdbId(id)),
// });

export const useSelectAdbSite = () => {
  const utilisateurConnecte = useSelector((state: Types.RootState) =>
    UtilisateurSelector.getUtilisateurConnecte(state)
  );
  const adbDetail = useSelector((state: Types.RootState) =>
    AdbSelector.getADBDetail(state)
  );

  const selectedAdbDetail = useSelector((state: Types.RootState) =>
    AdbSelector.getADBDetail(state)
  );

  const selectedSiteDetails = useSelector((state: Types.RootState) =>
    AdbSelector.getSelectedSite(state)
  );

  const adbId = useSelector((state: Types.RootState) =>
    AdbSelector.getAdbId(state)
  );
  const {
    mutate: getAdbDetail,
    isLoading: adbFetching,
    error: adbError,
  } = useGetAdbDetail();

  const dispatch = useDispatch();

  const setSelectedSite = (site?: Site) => {
    site && dispatch(AdbActionCreator.setSelectedSite(site));
  };

  const updateAdbId = (id: number) => {
    dispatch(AdbActionCreator.updateAdbId(id));
  };
  return {
    utilisateurConnecte,
    getAdbDetail,
    adbFetching,
    adbError,
    adbDetail,
    selectedAdbDetail,
    selectedSiteDetails,
    adbId,
    setSelectedSite,
    updateAdbId,
  };
};
